var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"flat":_vm.flat}},[(_vm.title)?_c('v-card-title',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_c('v-card-text',[_c('v-chart',{style:({ height: _vm.height, width: _vm.width }),attrs:{"option":_vm.mergedOptions,"autoresize":true},on:{"click":_vm.handleClick,"dblclick":_vm.handleDblClick}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-decb5708","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/BaseChart.vue
// module id = null
// module chunks = 